import currencies from './currencies.js';
import langs from './langs';

const formatPrice = (price, currency, lang, override) => {
    if (typeof price === 'string') {
        return /\d+[,. ]?/g.test(price) ? price : null;
    }

    const format = Object.assign({}, 
        currencies[currency] || { decimalDigits: 2, thousandsSeparator: '.' },
        langs[lang],
        override
    );

    const symbol = format.symbol || '';
    const decimalDigits = format.decimalDigits;
    const decimalPadding = format.decimalPadding || decimalDigits;
    const decimalSeparator = format.decimalSeparator || ',';
    const thousandsSeparator = format.thousandsSeparator;
    const space = format.spaceBetweenAmountAndSymbol ? ' ' : '';

    const formattedPrice = (+price.toFixed(decimalDigits))
        .toFixed(decimalPadding)
        .replace('.', decimalSeparator)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandsSeparator);

    return format.symbolOnLeft
        ? symbol + space + formattedPrice
        : formattedPrice + space + symbol;
};

const truncatePrice = (price, currency) => {
    if (typeof price !== 'number') {
        return NaN;
    }
    const format = currencies[currency] || { decimalDigits: 2 };

    return +price.toFixed(format.decimalDigits);
};

export { formatPrice, truncatePrice };
